import React from "react"
import { useTranslation } from "react-i18next"

import { ConfirmationOverlay } from "shared/ui/confirmation-overlay/ConfirmationOverlay"

import { DeleteProductPositionsOverlayModel } from "./hooks/useDeleteProductPositionsOverlayModel"

export const DeleteProductPositionOverlayView = React.memo(
  ({ confirm, closeOverlay }: DeleteProductPositionsOverlayModel) => {
    const { t } = useTranslation()
    return (
      <ConfirmationOverlay.Root id="delete-product-positions-overlay" isDanger>
        <ConfirmationOverlay.Header>
          <ConfirmationOverlay.Title>
            {t("ProductPosition.Actions.Delete")}
          </ConfirmationOverlay.Title>
        </ConfirmationOverlay.Header>
        <ConfirmationOverlay.Message>
          {t("ProductPosition.DeleteConfirmation")}
        </ConfirmationOverlay.Message>
        <ConfirmationOverlay.Actions>
          <ConfirmationOverlay.Cancel onClick={closeOverlay} />
          <ConfirmationOverlay.Submit onClick={confirm}>
            {t("General.Delete")}
          </ConfirmationOverlay.Submit>
        </ConfirmationOverlay.Actions>
      </ConfirmationOverlay.Root>
    )
  }
)
